export class DrugSearchTCCDetails {
  groupId: number;
  therCat1Nm: string;
  therCat1MbrGuiNm: string;
  therClass1Nm: string;
  therClass1MbrGuiNm: string;

  therCat2Nm: string;
  therCat2MbrGuiNm: string;
  therClass2Nm: string;
  therClass2MbrGuiNm: string;

  therCat3Nm: string;
  therCat3MbrGuiNm: string;
  therClass3Nm: string;
  therClass3MbrGuiNm: string;
}
